angular.module('TetherApp').controller('ContactController', [
    '$scope',
    'contactService',
    function ($scope, contactService) {

        let self = this;

        self.email = '';
        self.message = '';

        let onError = function(reason) {
            self.error = 'Could not fetch the data.';
        };

        let onCreate = function (data) {
            //Do nothing
        };

        self.createContact = function() {
            if (self.email != undefined && self.email != '' && self.message != undefined && self.message != '' ) {
                contactService.sendContact(
                    self.email,
                    self.message
                ).then(onCreate, onError);
            }
        };

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };
    }
]);
